import { ReactNode } from 'react'

import clsx from 'clsx'

import Text from '@/components/view/atoms/text/Text'

interface Props {
  title: string
  badgeNode?: ReactNode
  behindNode?: ReactNode
  rightNode?: ReactNode
  description?: string
}

const PageTitle = ({ title, badgeNode, behindNode, rightNode, description }: Props) => {
  return (
    <>
      {badgeNode && <div className='pb-2'>{badgeNode}</div>}
      <div
        className={clsx(
          'flex w-full items-center justify-between gap-1',
          !badgeNode && 'pt-6',
          !description && 'pb-6'
        )}
      >
        <div className='inline-flex items-center justify-start gap-x-2'>
          <div className='inline-flex items-center justify-start gap-x-1'>
            <Text size={24} weight={'bold'} lineHeight={150} tag={'h1'} truncate>
              {title}
            </Text>
          </div>
          {behindNode && <>{behindNode}</>}
        </div>
        {rightNode && (
          <div className='ml-auto inline-flex shrink-0 flex-wrap items-center justify-end gap-x-2 gap-y-1'>
            {rightNode}
          </div>
        )}
      </div>
      {description && (
        <div className='pb-6'>
          <Text size={12}>{description}</Text>
        </div>
      )}
    </>
  )
}

export default PageTitle
